export interface RequestParam {
  url: string;
  headers?: { [header: string]: string };
  params?: {
    [param: string]:
      | string
      | number
      | boolean
      | ReadonlyArray<string | number | boolean>;
  };
}

export const DEFAULT_HEADERS: { [header: string]: string } = {
  'Content-Type': 'application/json',
};
